import { FC } from 'react'
import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import HalfDonutChart from './HalfDonutChart'

interface Props {
  performanceScore: number
  lastMonthChange?: number | null
}

const CurrentViewWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 42px 0 40px 0;
  justify-content: center;
`

const CurrentScoreView: FC<Props> = ({ performanceScore, lastMonthChange }) => (
  <CurrentViewWrapper>
    <HalfDonutChart value={performanceScore} lastMonthChange={lastMonthChange} size={350} />
  </CurrentViewWrapper>
)

export default CurrentScoreView
